import React from "react";
import withStyles from '@mui/styles/withStyles';
const styles = (theme) => ({
  button: {
    boxShadow: "0px 3px 20px #00000026",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "-0.26px",
    margin: "14px 26px 28px 26px",
    padding: "18px 26px",
    borderRadius: "25px",
    display: "flex",
    alignItems: "center",
  },
  arrow: {
    marginRight: "16px",
  },
  buttonTitle: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
  },
});
const RoundButton = ({
  classes,
  children,
  arrow,
  color = "#FFFFFF",
  backgroundColor = "#FFAB9D",
  onClick,
}) => {
  return (
    <div
      style={{ backgroundColor: backgroundColor, color: color }}
      className={classes.button}
      onClick={onClick}
    >
      <img className={classes.arrow} src={arrow} alt="" />
      <span className={classes.buttonTitle}>{children}</span>
    </div>
  );
};
export default withStyles(styles)(RoundButton);
